var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Imóvel/Denominação" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Denominação do Imóvel:" }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            name: "Denominação do Imóvel",
                            maxlength: "300"
                          },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase(
                                $event,
                                "imovel",
                                "denominacao"
                              )
                            }
                          },
                          model: {
                            value: _vm.imovel.denominacao,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "denominacao", $$v)
                            },
                            expression: "imovel.denominacao"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Imóvel/gleba" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Gleba:" } }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Gleba", maxlength: "300" },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase($event, "imovel", "gleba")
                            }
                          },
                          model: {
                            value: _vm.imovel.gleba,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "gleba", $$v)
                            },
                            expression: "imovel.gleba"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 6 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Imóvel/localizaçãosede" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "UF localização da sede:" }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            name: "UF localização da sede",
                            maxlength: "300",
                            disabled: true
                          },
                          model: {
                            value: _vm.imovel.ufLocalizacaoSede,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "ufLocalizacaoSede", $$v)
                            },
                            expression: "imovel.ufLocalizacaoSede"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Imóvel/Município" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Município:" } }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              "no-match-text": "Nenhum Município Encontrado",
                              placeholder: "Selecione",
                              filterable: "filterable",
                              clearable: "clearable",
                              "value-key": "id",
                              name: "Município"
                            },
                            on: {
                              clear: function($event) {
                                _vm.imovel.municipio = null
                              }
                            },
                            model: {
                              value: _vm.imovel.municipio,
                              callback: function($$v) {
                                _vm.$set(_vm.imovel, "municipio", $$v)
                              },
                              expression: "imovel.municipio"
                            }
                          },
                          _vm._l(_vm.municipios, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.nome, value: item }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("el-col", { staticClass: "inputDiv", attrs: { span: 8 } }, [
            _c(
              "div",
              { staticClass: "inputArea" },
              [
                _c("validation-provider", {
                  attrs: { rules: _vm.isRequiredArea, name: "Imóvel/Área" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", { attrs: { label: "Área:" } }),
                          _c("app-double-input", {
                            staticClass: "input",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Área",
                              precision: 4,
                              onkeypress: _vm.onlyInputNumbers,
                              showAppend: false
                            },
                            model: {
                              value: _vm.imovel.area,
                              callback: function($$v) {
                                _vm.$set(_vm.imovel, "area", $$v)
                              },
                              expression: "imovel.area"
                            }
                          }),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ]),
                          _vm.imovel.area && _vm.imovel.tipoArea
                            ? _c("p", { staticClass: "conversao" }, [
                                _vm._v(
                                  "Conversão: " +
                                    _vm._s(_vm.conversaoAreaCadastro())
                                )
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                }),
                _c("validation-provider", {
                  attrs: { rules: "required", name: "Imóvel/TipoArea" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", { attrs: { label: "Tipo:" } }),
                          _c(
                            "el-select",
                            {
                              staticClass: "input select",
                              class: { erro: errors.length },
                              attrs: {
                                placeholder: "Selecione",
                                filterable: "filterable",
                                clearable: "clearable",
                                "value-key": "id",
                                name: "Tipo"
                              },
                              on: {
                                clear: function($event) {
                                  _vm.imovel.tipoArea = null
                                }
                              },
                              model: {
                                value: _vm.imovel.tipoArea,
                                callback: function($$v) {
                                  _vm.$set(_vm.imovel, "tipoArea", $$v)
                                },
                                expression: "imovel.tipoArea"
                              }
                            },
                            _vm._l(_vm.tiposArea, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.nome, value: item.codigo }
                              })
                            }),
                            1
                          ),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Imóvel/Localização" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Localização:" } }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            name: "Localização",
                            type: "textarea",
                            rows: 5
                          },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase(
                                $event,
                                "imovel",
                                "localizacao"
                              )
                            }
                          },
                          model: {
                            value: _vm.imovel.localizacao,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "localizacao", $$v)
                            },
                            expression: "imovel.localizacao"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _c("validation-provider", {
                attrs: { name: "Imóvel/Latitude" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Latitude:", required: false }
                        }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: ["##°##'##,###\"A"],
                              expression: "[`##°##'##,###\"A`]"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Latitude" },
                          model: {
                            value: _vm.imovel.latitude,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "latitude", $$v)
                            },
                            expression: "imovel.latitude"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _c("validation-provider", {
                attrs: { name: "Imóvel/Longitude" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Longitude:", required: false }
                        }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: ["##°##'##,###\"A"],
                              expression: "[`##°##'##,###\"A`]"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Longitude" },
                          model: {
                            value: _vm.imovel.longitude,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "longitude", $$v)
                            },
                            expression: "imovel.longitude"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 13 } },
            [
              _c("validation-provider", {
                attrs: { name: "Imóvel/Logradouro" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Logradouro:", required: false }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Logradouro" },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase(
                                $event,
                                "imovel",
                                "logradouro"
                              )
                            }
                          },
                          model: {
                            value: _vm.imovel.logradouro,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "logradouro", $$v)
                            },
                            expression: "imovel.logradouro"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Imóvel/Bairro" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Bairro/Povoado", required: true }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Bairro" },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase($event, "imovel", "bairro")
                            }
                          },
                          model: {
                            value: _vm.imovel.bairro,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "bairro", $$v)
                            },
                            expression: "imovel.bairro"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { name: "Imóvel/Número" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Número:", required: false }
                        }),
                        _c(
                          "el-input",
                          {
                            staticClass: "input",
                            class: { erro: errors.length },
                            attrs: {
                              name: "numero",
                              disabled: _vm.imovel.semNumero,
                              onkeypress: _vm.onlyInputNumbers,
                              maxlength: "10",
                              showAppend: true
                            },
                            model: {
                              value: _vm.imovel.numero,
                              callback: function($$v) {
                                _vm.$set(_vm.imovel, "numero", $$v)
                              },
                              expression: "imovel.numero"
                            }
                          },
                          [
                            _c("el-checkbox", {
                              staticClass: "input",
                              attrs: { slot: "prepend", label: "S/N" },
                              on: { change: _vm.onSemNumeroCheck },
                              slot: "prepend",
                              model: {
                                value: _vm.imovel.semNumero,
                                callback: function($$v) {
                                  _vm.$set(_vm.imovel, "semNumero", $$v)
                                },
                                expression: "imovel.semNumero"
                              }
                            })
                          ],
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64d757e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d757e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/maranhao/processoFisico/components/DominacaoImovel.vue
// module id = null
// module chunks = 